import edu from "./education/en";
import lib from "./library/en";
import al from "./assets/en";
import vm from "./videoMoments/en";
import iv from "./interview/en";
import lvl from "./level/en";
import pm from "./practice/en";
// Phase 5.3 — English locale (CANONICAL key set). All other locales mirror these keys.
// Keys are stable identifiers; never use translated text as a DB id.
// Plural values use an object keyed by Intl.PluralRules categories (one/other/…).
// Interpolate variables with {name}.
const en = {
  footer: { forSchools: "For schools", tagline: "Your life becomes your language course.", eu: "Built for the EU 🇪🇺 · GDPR-first · We never store your photos or voice.", product: "Product", signIn: "Sign in", getStarted: "Get started", legal: "Legal", privacy: "Privacy Policy", terms: "Terms of Service" },
  cookie: { title: "We value your privacy 🍪", body: "GetFluentLoop uses essential cookies to keep you signed in. We never sell your data and we never store your raw photos or voice recordings. See our", link: "Privacy Policy", end: ".", accept: "Accept", decline: "Decline" },
  cefr: {"A1": "I know a few words", "A2": "Simple everyday phrases", "B1": "I can hold a basic chat", "B2": "I'm fairly fluent", "C1": "I'm very comfortable", "C2": "Near-native"},
  landing: { imgAlt: "Learner", streakBadge: {"one": "{count} day streak!", "other": "{count} day streak!"}, heroSub: "Learn from what you see, think, say, read and experience — while GetFluentLoop adapts the language around your real life. Start free in seconds.","freeTag": "FREE", "featJournal": "Voice Journal", "featToday": "Intelligent Today", "descLoop": "See something? Snap it and learn the word instantly.", "descFriend": "Think something? Say it naturally — talk about your life in the language you're learning.", "descLens": "Read signs, menus, objects and scenes around you — and learn from them.", "descJournal": "Speak or write your day in your own words. Hear it naturally in your new language.", "descToday": "Come back tomorrow: your learning Brain builds the next small lesson around what matters to you.", "mockLearned": "You learned today", "mockGloss": "The tree is very tall."},
  dash: { freezeSaved: {"one": "🛡️ A Streak Freeze saved your {count}-day streak!", "other": "🛡️ A Streak Freeze saved your {count}-day streak!"},"hey": "Hey {name} 👋", "heyAnon": "Hey there 👋", "learning": "Learning {lang} · Level {level}", "recap": "Week in review", "upgrade": "Upgrade to Pro", "todayLoop": "Today's Loop", "todayLoopSub": "Your personalized 5-minute session — start now", "classAssignments": "Class assignments", "viewAll": "View all →", "continue": "Continue", "start": "Start", "allCaught": "All caught up — nice work! 🎉", "momentum": "Your momentum", "freezeHelp": "Streak Freezes protect your streak on a missed day", "freezes": {"one": "{count} freeze", "other": "{count} freezes"}, "streakCalendar": "View streak calendar →", "totalXp": "total XP", "wordsLearned": "words learned", "dueForReview": "due for review →", "captures": "captures", "conversations": "conversations", "accentTrend": "Accent trend", "noScores": "No scores yet — try", "noScoresEnd": ".", "recent": "Recent activity", "nothingYet": "Nothing yet. Start capturing!", "jumpBack": "Jump back in"},
  nudge: {"streakTitle": {"one": "Keep your {count}-day streak alive!", "other": "Keep your {count}-day streak alive!"}, "streakSub": "Do your Today's Loop so you don't lose it.", "startLoop": "Start Loop", "dueTitle": {"one": "{count} word is due for review", "other": "{count} words are due for review"}, "dueSub": "A 2-minute Loop keeps them in long-term memory.", "reviewNow": "Review now"},
  tour: {"t1": "Welcome to GetFluentLoop! 🎉", "b1": "One app that turns your everyday life into your language course — every feature feeds one shared vocab bank.", "t2": "Point your camera", "b2": "LanguageLoop turns anything around you into a word: snap a photo, get the word, a sentence and pronunciation.", "t3": "Practice for real", "b3": "Chat with your AI Roommate, score your accent, debate a topic, and quiz your own words.", "t4": "Today's Loop", "b4": "Not sure where to start? Tap Today's Loop for a personalized 5-minute session, every day.", "t5": "Build a streak", "b5": "Practice daily to grow your streak — and bank Streak Freezes so one busy day never breaks it.", "back": "Back", "next": "Next", "start": "Start learning", "skip": "Skip tour"},
  vocabSrc: {"manual": "Added by you", "mission": "Mission", "word_explorer": "Word Explorer", "object_lens": "FluentLens · Object", "scene_lens": "FluentLens · Scene", "text_lens": "FluentLens · Text", "fluent_friend_live": "Live Friend"},
  common: {
    save: "Save", cancel: "Cancel", add: "Add", addSelected: "Add selected",
    addAll: "Add all useful words", delete: "Delete", edit: "Edit", retake: "Retake",
    scanAgain: "Scan again", continue: "Continue", back: "Back", next: "Next",
    close: "Close", loading: "Loading…", search: "Search", logout: "Log out",
    settings: "Settings", listen: "Listen", stop: "Stop", added: "Added",
  },
  nav: {
    educationadmin: "Education Admin",
    more: "More",
    dashboard: "Dashboard", today: "Today", languageloop: "LanguageLoop",
    fluentlens: "FluentLens", roommate: "Roommate", accentcoach: "AccentCoach",
    debategym: "DebateGym", quizforge: "QuizForge", story: "Story",
    "vocab bank": "Vocab Bank", "discovery lab": "Discovery Lab", assignments: "Assignments", myclasses: "My classes", teacher: "Teacher", journal: "Journal", friend: "Friend",
  },
  auth: { welcomeBack: "Welcome back!", welcomeNew: "Welcome to GetFluentLoop! 🎉",
    signInTitle: "Welcome back", signUpTitle: "Create your account",
    signInSub: "Sign in to keep learning.", signUpSub: "Start learning in under a minute.",
    continueWithGoogle: "Continue with Google", or: "OR", yourName: "Your name",
    email: "Email", password: "Password", iSpeak: "I speak", imLearning: "I'm learning",
    myLevel: "My level", createAccount: "Create account", signIn: "Sign in",
    acceptTerms: "I accept the Terms and Privacy Policy.",
    haveAccount: "Already have an account?", noAccount: "New here?",
  },
  onboarding: {
    allSet: "You're all set! 🎉",
    welcome: "Welcome to GetFluentLoop", title: "Let's set you up",
    subtitle: "Tell us what you're learning.", iSpeak: "I speak",
    imLearning: "I'm learning", level: "Level", finish: "Start learning",
    allSet: "You're all set! 🎉",
  },
  settings: {
    title: "Settings", interfaceLanguage: "Interface language",
    interfaceLanguageHelp: "The language of menus, buttons and messages. This does not change what you're learning.",
    learning: "Learning", native: "Native", level: "Level",
    learningProfiles: "Learning profiles",
    learningProfilesHelp: "Keep several languages under one account. Switching changes only your personal learning context — your account, role and schools stay the same.",
    addProfile: "Add language profile", switch: "Switch", active: "Active",
    createAndSwitch: "Create & switch", nameOptional: "Name (optional)",
    pickDifferent: "Pick two different languages to speak and learn.",
    profileSwitched: "Learning profile switched",
  },
  lens: {
    home: "FluentLens", tagline: "Point your camera at the world and learn the language around it.",
    textLens: "Text Lens", objectLens: "Object Lens", studyLens: "Study Lens",
    sceneLens: "Scene Lens", takePhoto: "Take photo", uploadImage: "Upload image",
    translate: "Translate", explain: "Explain", quizMe: "Quiz Me", describe: "Describe",
    identifyCount: "Identify & Count", learnVocab: "Learn Vocabulary",
    saveScan: "Save to Archive", archive: "Archive", usefulVocab: "Useful vocabulary",
    naturalTranslation: "Natural translation", gist: "Gist", check: "Check",
    addWord: "Add word", addRelated: "Add related words", wordsAround: "Words around it",
    whereThings: "Where things are", suggestedAnswer: "Suggested answer",
  },
  mission: {
    speak: "Speak", type: "Type", startRecording: "Tap to speak", stop: "Stop",
    retry: "Retry", usefulPhrases: "Useful phrases", wordsToRemember: "Words to remember",
    completeMission: "Complete mission", nextStep: "Next step", recap: "learning recap",
    showRecap: "Show", hideRecap: "Hide", typeFirst: "Type your first reply to start.",
    speakFirst: "Tap the mic and say your first line to start.",
    typeReply: "Type your reply…",
  },
  home: {
    badge: "🇪🇺 EU-Built · GDPR-first · Global by design",
    heroPre: "Your life becomes", heroPost: "your language", heroWord: "course",
    getStarted: "Get started", signIn: "Sign in", dashboard: "Dashboard",
    tryFree: "Try LanguageLoop free", startLearning: "Start learning",
    privacy: "No photo or recording is ever stored. Ever.",
    bundlesTitle: "Everything feeds one learning loop.",
    bundlesSub: "Discover a word anywhere, then explore and remember it. Every feature shares one vocabulary bank, one memory of what you know, and one calm daily plan.",
    priceSub: "Everything included. Cancel anytime.", startNow: "Start now",
  },
  pilot: {
    // plural example — Intl.PluralRules categories
    daysRemaining: { one: "{count} day left", other: "{count} days left" },
  },
  today: { dueSoon: "Due soon", overdue: "Overdue", continueMission: "Continue your class mission", yourMission: "Your class mission", minutes: {"one": "~{count} min", "other": "~{count} min"}, stepsProgress: "{done}/{total} steps", wordProgress: "Word {n} / {total}", unlockPro: "Unlock with Pro", skipForNow: "Skip for now", weHeard: "We heard:", skip: "Skip", snapHint: "Snap any object around you to add a fresh word to your bank.", doLater: "I'll do it later", bonusXp: {"one": "+{count} XP bonus", "other": "+{count} XP bonus"}, micUnavailable: "Mic unavailable.", scoringFailed: "Scoring failed.", paywallReason: "Pronunciation scoring is part of GetFluentLoop Pro.",
    title: "Today's Loop", subtitle: "Your personalized 5-minute session.",
    dayStreak: { one: "day streak", other: "day streak" }, streakText: {"one": "{count} day streak", "other": "{count} day streak"}, startLoop: "Start today's loop", reveal: "Reveal answer",
    gotIt: "Got it", missedIt: "Missed it", sayItOut: "Say it out loud", hearIt: "Hear it",
    skip: "Skip", continue: "Continue", loopComplete: "Loop complete!",
    loopCompleteToday: "Loop complete for today!", comeBack: "Come back tomorrow.",
    backToDashboard: "Back to dashboard", word: "Word", reviewWords: "Review words",
    saySentence: "Say a sentence", captureNew: "Capture something new",
    openCamera: "Open camera", learnNewWord: "Learn one new word", practiceAgain: "Practice again anyway",
  },
  wordExplorer: {
    script: "Script",
    scriptSaved: "Script preference saved",
    pos: {
      noun: "noun",
      verb: "verb",
      adjective: "adjective",
      adverb: "adverb",
      pronoun: "pronoun",
      preposition: "preposition",
      conjunction: "conjunction",
      phrase: "phrase",
      other: "other",
      related: "related",
    },
    labels: {
      present: "Present",
      past_compose: "Past (passé composé)",
      past_preterite: "Past (pretérito)",
      imperfect: "Imperfect",
      future: "Future",
      conditional: "Conditional",
      subjunctive: "Subjunctive",
      singular: "Singular",
      plural: "Plural",
      nominative: "Nominative",
      genitive: "Genitive",
      dative: "Dative",
      accusative: "Accusative",
      instrumental: "Instrumental",
      prepositional: "Prepositional",
      present_imperfective: "Present (imperfective)",
      future_perfective: "Future (perfective)",
      past: "Past",
      imperative: "Imperative",
      forms: "Forms",
      masculine: "masculine",
      feminine: "feminine",
      neuter: "neuter",
      short_m: "short m.",
      short_f: "short f.",
      short_forms: "Short forms",
    },
    explore: "Explore",
    exploreWord: "Explore “{word}”",
    title: "Word Explorer",
    howChanges: "How this word changes",
    seeMoreForms: "See more forms",
    family: "Word family",
    usage: "How people actually use it",
    traps: "Common traps",
    examples: "Natural examples",
    save: "Save to vocabulary",
    saved: "Saved to vocabulary",
    aiAssisted: "AI-assisted forms",
    aiAssistedHelp: "These forms were generated and checked automatically.",
    unlock: "Unlock Word Explorer with Pro",
    unlockSub: "See every useful form, the word family, real usage, common traps and more examples.",
    unlockCta: "Unlock with Pro",
    more: "More usage & examples",
    loading: "Exploring…",
    failed: "We couldn't explore that word. Check the spelling and try again.",
    back: "Vocabulary",
    listen: "Listen",
    alsoMeans: "Also",
  },
  vocab: { markKnown: "Mark known",
    title: "Vocab Bank", subtitle: "Every word you've learned.", searchWords: "Search words…",
    all: "All", known: "Known", learning: "Learning", removed: "Removed", markKnown: "Mark known",
    empty: "No words yet. Go capture some with FluentLens!",
  },
  journal: {
    title: "Voice Journal", tagline: "Speak your life. Learn how to say it.",
    speak: "Speak", type: "Type instead", recording: "Recording… tap to stop",
    typePlaceholder: "Write in your language…",
    intro: "Talk about your day, your plans or how you feel — in your own language.",
    review: "Review your thought", reviewHelp: "Check the transcript and fix anything before we translate it.",
    retry: "Record again", seeHowToSay: "See how to say it",
    whatYouSaid: "What you said", howToSay: "How to say it in {lang}",
    practice: "Practice saying it", practicing: "Recording your practice…", playYours: "Hear your attempt",
    usefulWords: "Useful words", usefulPhrases: "Useful phrases", grammar: "Grammar worth noticing",
    actions: "Possible actions", saveEntry: "Save to journal", saved: "Saved to your journal",
    archive: "Your journal", empty: "No entries yet — speak or type your first thought.",
    newEntry: "New entry", rename: "Rename title", deleted: "Entry deleted",
    micDenied: "Microphone unavailable — type instead.", analyzing: "Finding the natural way to say it…",
    transcribing: "Listening…",
  },
  friend: {
    live: {
      "premium": "Fluent Friend is a premium feature.",
      "voiceUnavailable": "Voice unavailable right now.",
      "genericError": "Something went wrong. Please try again.",
      "start": "Start live conversation",
      "tag": "Live",
      "intro": "Speak directly in the language you're learning. Fluent Friend will keep the conversation going. If you get stuck, use “Help me say this.”",
      "ideas": "Ideas to start",
      "speak": "Speak",
      "stop": "Stop",
      "type": "Type in the language you're learning…",
      "help": "Help me say this",
      "helpTitle": "Say it in your own language",
      "helpPlaceholder": "Say or type what you mean…",
      "helpGo": "Show me how to say it",
      "helped": "You wanted to say",
      "end": "End conversation",
      "voice": "Friend voice",
      "listening": "Listening…",
      "understanding": "Understanding…",
      "thinking": "Thinking…",
      "retry": "Try again",
      "replyFailed": "Fluent Friend couldn't reply just now — your message is safe.",
      "sttFailed": "We couldn't catch that. Try again or type instead.",
      "meaning": "Show meaning",
      "saved": "Conversation saved.",
      "recapTitle": "What you practiced",
      "keep": "Expressions worth keeping",
      "addAll": "Add all useful",
      "moreNatural": "One thing to say more naturally",
      "handledWell": "Something you handled well",
      "practiceAgain": "Worth practicing again",
      "starter": {
        "day": "Tell me about your day",
        "plans": "What are you planning?",
        "happened": "Something interesting happened?",
        "work": "Want to talk about work or study?",
        "forward": "What are you looking forward to?"
      }
    },
    title: "Fluent Friend", tagline: "Talk about your life. Learn through the conversation.",
    intro: "Speak naturally in your own language. Fluent Friend helps you say it in {lang} — then keeps the conversation going there.",
    introText: "Write naturally in your own language. Say what you would really want to express — Fluent Friend helps you say it in {lang} and keeps the conversation going there.",
    speak: "Speak", type: "Type", send: "Send", placeholder: "Say something in your language…",
    reviewHint: "Check what you said, then send.", youCouldSay: "You could say",
    showMeaning: "Show meaning", hideMeaning: "Hide meaning",
    recap: "What you practiced", newChat: "New conversation", conversations: "Conversations",
    empty: "No conversations yet — start talking about your day.",
    startersTitle: "Not sure where to start?",
    starters: ["Tell me about your day", "Something on your mind?", "What are you planning?", "Want to talk about work?", "Tell me something good that happened", "What are you looking forward to?"],
    words: "Useful words", phrases: "Useful phrases", expressions: "Natural expressions",
    grammar: "Grammar worth noticing", practiceAgain: "Worth practicing again",
    thinking: "Fluent Friend is replying…", recording: "Recording… tap to stop",
    micDenied: "Microphone unavailable — type instead.",
  },
  teacher: { dashboard: "Teacher Dashboard", myClasses: "My Classes" },  education: {
    title: "FluentLoop for Education",
    pilotLine: "90-Day School Pilot — Free for Verified Schools.",
    apply: "Apply for the 90-Day Pilot", submitting: "Submitting…",
  },
  assignments: {
    title: "My Assignments", subtitle: "Missions your teacher has set for you.",
    empty: "No assignments right now 🎉", emptySub: "When your teacher assigns a Fluency Mission, it'll appear here.",
    doTodayLoop: "Do Today's Loop", toDo: "To do", inProgress: "In progress", completed: "Completed",
    start: "Start", continue: "Continue", done: "Done", late: "(late)",
    overdue: "Overdue", dueToday: "Due today", dueSoon: "Due soon", scheduled: "Scheduled",
  },
  label: {
    gist: "Gist", vocabulary: "Vocabulary", usefulPhrases: "Useful phrases", grammar: "Grammar",
    verbs: "Verbs", adjectives: "Adjectives", idioms: "Idioms & collocations", relatedWords: "Related words",
    example: "Example", naturalTranslation: "Natural translation", whereThings: "Where things are",
    reanalyze: "Re-analyze", save: "Save", plural: "plural",
  },
  missionRun: {
    breadcrumb: "Assignments", notAvailable: "This mission isn't available to you.",
    backToAssignments: "Back to assignments", complete: "Mission complete!",
    completeDesc: "You finished {title}.",
    myAssignments: "My assignments", dashboard: "Dashboard", yourClass: "Your class",
    stepOf: "Step {current} of {total}", optional: "optional",
    back: "Back", nextStep: "Next step", continueBonus: "Continue to bonus",
    completeMission: "Complete mission", finishEarly: "I'm done — complete the mission",
    keepWords: "Keep these words for your own practice?", saveToBank: "Save to my Vocab Bank", notNow: "Not now", savedToBank: "Saved to your Vocab Bank.", backToClass: "Back to class", cantSave: "These words can't be saved to your Vocab Bank because this mission's language isn't one of your learning languages.", saveFailed: "Couldn't save the words. Please try again.",
  },
  lensDesc: {
    text: "Translate difficult passages, understand vocabulary and grammar.",
    object: "Discover what something is called and learn the language around it.",
    scene: "See the whole scene — describe it, count things and learn the language around it.",
    study: "Turn real-world reading into comprehension practice.",
    archiveSub: "Reopen past scans, revisit vocabulary, retry study sessions.",
    hintText: "Point at a book, sign, menu or letter", hintObject: "Point at an object, plant or animal",
    hintScene: "Point at a meal, table, room or landscape", captureHelp: "Take a photo or upload one.",
    subText: "Scan a passage to translate, explain, or study it.",
    subObject: "Point at something to learn its name and the language around it.",
    subScene: "See the whole scene. Learn the language around it.",
    subStudy: "Scan a passage and practice understanding it.",
    captureSub: "Snap or upload a photo of any object to learn its word.",
  },
  todayHelp: {
    refresh: "Refresh what's fading", score: "Score your pronunciation",
    snap: "Snap one object", proFeature: "Pro feature", proScoring: "Pronunciation scoring is a Pro feature",
  },
  capture: {
    title: "What's around you?", reading: "Reading the world…",
    pointHint: "Point at a cup, a tree, a dog…", anything: "Anything works.",
    learnMe: "Learn me", savedToBank: "Saved to your bank", shareCard: "Share card",
    building: "Building…", capReached: "You've hit your free daily captures.",
    keepStreak: "Keep your streak going!", signUpFree: "Sign up free", close: "Close",
    couldNotRead: "Could not read that image. Try another.",
  },
  review: {
    title: "Review", tagline: "Remember what matters.",
    progress: "{n} of {total}",
    dueCount: { one: "1 word is ready to review.", other: "{count} words are ready to review." },
    recentCount: { one: "Practice 1 recent word.", other: "Practice {count} recent words." },
    allDue: "All due", all: "All", start: { one: "Start · 1 card", other: "Start · {count} cards" },
    caughtUp: "You're caught up.", nothingDue: "Nothing needs reviewing right now.", practiceRecent: "Practice recent words",
    reveal: "Reveal", again: "Again", gotIt: "Got it", listen: "Listen",
    type: { recognition: "What does this mean?", recall: "How do you say this?", context: "Which word fits?", listening: "Listen — what is it?", typed: "Type it from memory" },
    typed: { label: "Type your answer", placeholder: "Type it in {lang}", check: "Check", correct: "Correct", notQuite: "Not quite", yourAnswer: "Your answer", answer: "Answer", showAnswer: "Show answer", suggestAgain: "Worth another look — Again brings it back sooner.", checkFailed: "Couldn't check that — try again." },
    complete: "Review complete", reviewed: "Reviewed", remembered: "Remembered", anotherLook: "Needs another look",
    nextIn: { one: "Next review in 1 day.", other: "Next review in {count} days." },
    done: "Done", backToday: "Back to Today", todayLink: { one: "Remember · 1 word due", other: "Remember · {count} words due" },
    voiceUnavailable: "Voice unavailable right now.", saveFailed: "Couldn't save that — try again.",
  },
  lc: {
    "title": "Your 5 minutes",
    "subtitle": "Made from what you're learning right now",
    "cold": "Your daily path will become more personal as FluentLoop learns what matters to you.",
    "forYou": "For you today",
    "assigned": "Assigned",
    "reason": {
      "due": "Coming back at the right time",
      "weak": "Worth recalling",
      "activation": "You've seen this but haven't used it yet",
      "relevant": "Recently saved",
      "recently_saved": "Recently saved",
      "stretch": "Take it a step further",
      "function_gap": "A useful skill to practice",
      "skill": "A useful skill to practice"
    },
    "kind": {
      "recall": "Remember",
      "retrieve": "Remember",
      "use_it": "Use it",
      "situation": "Situation"
    },
    "howSay": "How do you say this?",
    "write": "Write your answer…",
    "check": "Check",
    "skip": "Skip",
    "notUseful": "Not useful to me",
    "next": "Next",
    "natural": "Natural",
    "tip": "Tip",
    "alreadyNatural": "Your sentence already works naturally.",
    "example": "Example",
    "saved": "Saved",
    "useItTpl": "Use “{word}” in one sentence.",
    "useItTopicTpl": "Use “{word}” in one sentence about {topic}.",
    "situationTpl": "{function}: write 1–2 sentences about {topic}.",
    "doneTitle": "That's enough for today.",
    "recalled": "{count} recalled",
    "used": "{count} used",
    "situations": "{count} situation practiced",
    "keepGoing": "Keep going",
    "reviewAll": "Review all due words ({count})",
    "sayAloud": "Say a sentence out loud",
    "snapWord": "Snap a new word",
    "alsoToday": "Also today",
    "progress": "{n} of {total}",
    "loading": "Preparing your 5 minutes…",
    "fn": {
      "asking_question": "Asking a question",
      "requesting": "Making a request",
      "explaining_problem": "Explaining a problem",
      "describing": "Describing something",
      "narrating_past": "Telling what happened",
      "making_plans": "Making plans",
      "apologizing": "Apologizing",
      "agreeing_disagreeing": "Agreeing or disagreeing",
      "expressing_preference": "Saying what you prefer",
      "giving_opinion": "Giving your opinion",
      "clarifying": "Clarifying",
      "small_talk": "Small talk"
    },
    "topic": {
      "home": "home",
      "work": "work",
      "study": "studying",
      "food": "food",
      "travel": "travel",
      "transport": "getting around",
      "shopping": "shopping",
      "social_life": "friends and plans",
      "health_everyday": "everyday wellbeing",
      "money_everyday": "everyday costs",
      "hobbies": "hobbies",
      "culture": "culture",
      "nature": "nature",
      "technology": "technology",
      "everyday_life": "everyday life"
    }
  },
  errors: {
    generic: "Something went wrong. Please try again.",
    couldNotSave: "Could not save. Try again.",
  },
};
en.pm = pm;
en.lvl = lvl;
en.iv = iv;
en.vm = vm;
en.edu = edu;
en.lib = lib;
en.al = al;
export default en;
